import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propChildren, propFunc, propStr, } from '../../../helpers/custom-prop-types';
import FormRegistration from '../Registration/FormRegistration';
const LoginAlertRegistrationCard = (props) => {
    const { newHeaderDescription, newHeaderTitle, onSubmitEvent, registrationType, } = props;
    return (_jsx("div", Object.assign({ className: 'registration_modal' }, { children: _jsx(FormRegistration, { layoutType: 'new', newHeaderDescription: newHeaderDescription, newHeaderTitle: newHeaderTitle, registrationType: registrationType, requestDivisionLabelName: 'cardLabel', submitEvent: onSubmitEvent }) })));
};
LoginAlertRegistrationCard.propTypes = {
    newHeaderDescription: propChildren(),
    newHeaderTitle: propChildren(),
    onSubmitEvent: propFunc(),
    registrationType: propStr().isRequired,
};
LoginAlertRegistrationCard.defaultProps = {
    newHeaderDescription: undefined,
    newHeaderTitle: undefined,
    onSubmitEvent: undefined,
};
export default LoginAlertRegistrationCard;
